import { useLanguage } from '../context/LanguageContext';
import { Star, Quote } from 'lucide-react';

const TESTIMONIALS = [
  {
    id: 1,
    name: 'Maria G.',
    location: 'Buenos Aires, Argentina',
    rating: 5,
    it: 'Grazie a Italian Roots Discovery ho scoperto che la mia famiglia proviene da un piccolo paese in Calabria. Un\'esperienza emozionante che ha cambiato la mia vita.',
    en: 'Thanks to Italian Roots Discovery I found out my family comes from a small town in Calabria. An emotional experience that changed my life.',
    es: 'Gracias a Italian Roots Discovery descubrí que mi familia proviene de un pequeño pueblo en Calabria. Una experiencia emocionante que cambió mi vida.',
    pt: 'Graças ao Italian Roots Discovery descobri que minha família vem de uma pequena cidade na Calábria. Uma experiência emocionante que mudou minha vida.',
  },
  {
    id: 2,
    name: 'Robert T.',
    location: 'New York, USA',
    rating: 5,
    it: 'Il team ha trovato documenti del 1800 della mia famiglia a Napoli. Ho potuto ottenere la cittadinanza italiana grazie al loro supporto professionale.',
    en: 'The team found 1800s documents of my family in Naples. I was able to obtain Italian citizenship thanks to their professional support.',
    es: 'El equipo encontró documentos del siglo XIX de mi familia en Nápoles. Pude obtener la ciudadanía italiana gracias a su apoyo profesional.',
    pt: 'A equipe encontrou documentos do século XIX da minha família em Nápoles. Consegui obter a cidadania italiana graças ao seu apoio profissional.',
  },
  {
    id: 3,
    name: 'Isabella R.',
    location: 'São Paulo, Brazil',
    rating: 5,
    it: 'Il viaggio in Sicilia per visitare il paese dei miei bisnonni è stato il regalo più bello che potessi fare a mia madre. Laura e Giosia sono stati fantastici.',
    en: 'The trip to Sicily to visit my great-grandparents\' town was the most beautiful gift I could give my mother. Laura and Giosia were fantastic.',
    es: 'El viaje a Sicilia para visitar el pueblo de mis bisabuelos fue el regalo más hermoso que pude darle a mi madre. Laura y Giosia fueron fantásticos.',
    pt: 'A viagem à Sicília para visitar a cidade dos meus bisavós foi o presente mais bonito que pude dar à minha mãe. Laura e Giosia foram fantásticos.',
  },
];

const VideoTestimonialsSection = () => {
  const { language } = useLanguage();

  const title = {
    it: 'Le Storie dei Nostri Clienti',
    en: 'Our Clients\' Stories',
    es: 'Las Historias de Nuestros Clientes',
    pt: 'As Histórias dos Nossos Clientes',
  };

  const subtitle = {
    it: 'Scopri le esperienze di chi ha ritrovato le proprie radici italiane',
    en: 'Discover the experiences of those who found their Italian roots',
    es: 'Descubre las experiencias de quienes encontraron sus raíces italianas',
    pt: 'Descubra as experiências de quem encontrou suas raízes italianas',
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-blue-50/30" data-testid="video-testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-xs sm:text-sm tracking-[0.3em] uppercase text-blue-600 font-semibold mb-3">Testimonials</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {title[language] || title.it}
          </h2>
          <p className="text-base text-gray-500 mt-3 max-w-2xl mx-auto">{subtitle[language] || subtitle.it}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {TESTIMONIALS.map((t) => (
            <div
              key={t.id}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-300"
              data-testid={`testimonial-card-${t.id}`}
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <Quote className="w-6 h-6 text-blue-200 mb-3" />
              <p className="text-sm text-gray-600 leading-relaxed mb-5">
                {t[language] || t.it}
              </p>
              <div className="flex items-center gap-3 border-t border-gray-100 pt-4">
                <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-blue-600">{t.name.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">{t.name}</p>
                  <p className="text-xs text-gray-400">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoTestimonialsSection;
